import { AppFunctionComponent } from "../../../types"
import React, { useState } from "react"
import { resolveCurrentPageMenuPathFor } from "../../helpers/resolve-current-page-menu-path"
import { SubmenuItem } from "../../types/menu.interface"
import {
  NavigationWrapper,
  NavigationListWrapper,
  NavigationListItem,
  NavigationMainItemLink,
  Subnavigation,
} from "./navigation-list.styled"

interface Props {
  navigationItems: SubmenuItem[]
  pathname: string
}

const NavigationList: AppFunctionComponent<Props> = ({
  navigationItems,
  pathname,
  className,
}) => {
  const [hoveredItems, setHoveredItems] = useState(false)

  const currentPageMenuPath = resolveCurrentPageMenuPathFor(
    navigationItems,
    pathname
  )

  const [activeMenuPath, setActiveMenu] = useState<string | null>(
    currentPageMenuPath
  )
  const [[tappedPath, tapsCount], setTapCount] = useState<[string, number]>([
    "",
    0,
  ])

  const createSubmenuActivationHandler = (menuPath: string) => () => {
    setHoveredItems(true)
    return setActiveMenu(menuPath)
  }
  const deactivateSubmenu = () => {
    setHoveredItems(false)
    return setActiveMenu(currentPageMenuPath)
  }

  return (
    <NavigationWrapper>
      <NavigationListWrapper hovered={hoveredItems}>
        {navigationItems.map(({ subnavigationItem, displayName, path }) => {
          const withActiveSubMenu = path === activeMenuPath
          const onMainNavItemClick = (event: MouseEvent) => {
            // Prevent navigation on tablets on first tap.
            if (tappedPath === path && tapsCount === 1) {
              event.preventDefault()
            }
          }
          const onMainNavItemTouchEnd = () => {
            setTapCount(([path, count]) => [
              path,
              path === path ? count + 1 : 1,
            ])
            setActiveMenu(path)
          }
          return (
            <div key={path}>
              <NavigationListItem
                onMouseEnter={createSubmenuActivationHandler(path)}
                onFocus={createSubmenuActivationHandler(path)}
                onMouseLeave={deactivateSubmenu}
                onBlur={deactivateSubmenu}
              >
                <NavigationMainItemLink
                  to={path}
                  activeClassName={"active"}
                  partiallyActive
                  onClick={onMainNavItemClick}
                  onTouchEnd={onMainNavItemTouchEnd}
                  aria-haspopup={Boolean(subnavigationItem?.length)}
                >
                  {displayName}
                </NavigationMainItemLink>
                {subnavigationItem && (
                  <Subnavigation
                    title={displayName}
                    active={hoveredItems && withActiveSubMenu}
                    links={subnavigationItem}
                    className={className}
                  />
                )}
              </NavigationListItem>
            </div>
          )
        })}
      </NavigationListWrapper>
    </NavigationWrapper>
  )
}

export default NavigationList
